<template>
    <v-card v-if="expirations && expirations.length">
        <v-card-title>
            Filters
        </v-card-title>
        <v-card-text>
            <v-layout wrap align-center>
                <v-flex xs12 sm6 d-flex>
                    <v-select
                    :items="expirations"
                    label="Start"
                    v-model="start"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm6 d-flex>
                    <v-select
                    :items="expirations"
                    label="End"
                    v-model="end"
                    ></v-select>
                </v-flex>
                <v-flex xs12 d-flex v-if="rangeMin && rangeMax">
                    <v-range-slider
                    v-model="strikeRange"
                    label="strike"
                    thumb-label="always"
                    :max="rangeMax"
                    :min="rangeMin"
                    @change="emitStrikeRange"
                    :step="1"
                    ></v-range-slider>
                </v-flex>

            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
  props: {
    expirations: {
      type: Array,
    },
    options: {
      type: Object,
    },
  },
  data() {
    return {
      start: null,
      end: null,
      strikeRange: [0, 0],
      rangeMax: 0,
      rangeMin: 0,
    };
  },
  methods: {
    doEmitDateRange() {
      if (this.start && this.end) {
        const startDate = new Date(this.start);
        const endDate = new Date(this.end);
        if (endDate >= startDate) {
          this.$emit('daterange-selected', { start: this.start, end: this.end });
        }
      }
    },
    emitStrikeRange(val) {
      this.$emit('strikerange-selected', val);
    },
    doCalcMaxAndMins() {
      let max = 0;
      if (this.options) {
        Object.keys(this.options).forEach((expiration) => {
          max = Math.max(...this.options[expiration].map(o => o.strike));
        });
      }
      this.rangeMax = max;

      let min = 0;
      if (this.options) {
        Object.keys(this.options).forEach((expiration) => {
          min = Math.min(...this.options[expiration].map(o => o.strike));
        });
      }

      this.rangeMin = min;

      this.strikeRange[0] = min;
      this.strikeRange[1] = max;
      this.emitStrikeRange(this.strikeRange);
    },
  },
  computed: {
    // rangeMax() {

    // },
    // rangeMin() {

    // }
  },
  watch: {
    expirations() {
      this.start = null;
      this.end = null;
    },
    options() {
      this.doCalcMaxAndMins();
    },
    start() {
      this.doEmitDateRange();
    },
    end() {
      this.doEmitDateRange();
    },
  },
};
</script>
